import type { GuideStep } from "@/hooks/usePageGuide";

export const dashboardGuide: GuideStep[] = [
  {
    selector: "[data-guide='sidebar']",
    title: "القائمة الجانبية",
    description: "من هنا يمكنك الوصول لجميع أقسام النظام: الأطفال، الفصول، الدروس، التقارير والمزيد.",
    position: "left",
  },
  {
    selector: "[data-guide='header']",
    title: "شريط التنقل العلوي",
    description: "يعرض اسمك ويحتوي على الإشعارات وزر طي القائمة الجانبية.",
    position: "bottom",
  },
  {
    selector: "[data-guide='notifications']",
    title: "الإشعارات",
    description: "اضغط هنا لعرض آخر الإشعارات والتنبيهات المتعلقة بالحضانة.",
    position: "bottom",
  },
  {
    selector: "[data-guide='main-content']",
    title: "المحتوى الرئيسي",
    description: "هنا تظهر محتويات الصفحة الحالية. استكشف الأقسام المختلفة من القائمة الجانبية.",
    position: "top",
  },
];

export const parentDashboardGuide: GuideStep[] = [
  {
    selector: "[data-guide='sidebar']",
    title: "القائمة الجانبية",
    description: "تحتوي على لوحة ولي الأمر والإعدادات.",
    position: "left",
  },
  {
    selector: "[data-guide='main-content']",
    title: "لوحة ولي الأمر",
    description: "من هنا يمكنك متابعة أطفالك: الدروس، الواجبات، الحضور، والفواتير.",
    position: "top",
  },
];

// Map route paths to their guide definitions
export const pageGuides: Record<string, GuideStep[]> = {
  "/dashboard": dashboardGuide,
  "/dashboard/parent": parentDashboardGuide,
};

// Get guide for a given path, fallback to dashboard guide
export function getGuideForPath(path: string): GuideStep[] {
  return pageGuides[path] || dashboardGuide;
}
